/** Detect active Supabase session from persisted localStorage (same keys as index.html shell). */
export function isSupabaseUserLoggedIn(): boolean {
  if (typeof localStorage === 'undefined') return false;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key?.startsWith('sb-') || !key.endsWith('-auth-token')) continue;
      const value = localStorage.getItem(key);
      if (!value) continue;
      const parsed = JSON.parse(value) as {
        currentSession?: { user?: unknown; expires_at?: number; expiresAt?: number };
        user?: unknown;
        expires_at?: number;
        expiresAt?: number;
      };
      const session = parsed?.currentSession ?? parsed;
      if (!session) continue;
      const user = (session as { user?: unknown }).user ?? parsed?.user;
      if (!user) continue;
      const expiresAt =
        (session as { expires_at?: number; expiresAt?: number }).expires_at ??
        (session as { expires_at?: number; expiresAt?: number }).expiresAt ??
        parsed?.expires_at ??
        parsed?.expiresAt;
      if (expiresAt && expiresAt * 1000 < Date.now()) continue;
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/** Hide Megha chat widget for signed-in users (body class + !important; beats meghai.css). */
export function setMeghaChatHiddenForLoggedInUser(hidden: boolean): void {
  if (typeof document === 'undefined') return;
  document.body.classList.toggle('megha-user-logged-in', hidden);
  const widget = document.querySelector('.megha-chat-widget') as HTMLElement | null;
  if (!widget) return;
  if (hidden) {
    // meghai.css sets display/visibility with !important — must override the same way
    widget.style.setProperty('display', 'none', 'important');
    widget.style.setProperty('visibility', 'hidden', 'important');
    widget.setAttribute('aria-hidden', 'true');
  } else {
    widget.style.removeProperty('display');
    widget.style.removeProperty('visibility');
    widget.removeAttribute('aria-hidden');
  }
}
